import {types} from '../HarvesterUploadActions';

const defaultState = {};

export default function (state = defaultState, action) {
  switch (action.type) {
    case types.FILTER:
    case types.FETCH:
    case types.FETCH_PENDING:
    case types.FETCH_SUCCESS:
    case types.FETCH_ERROR:
    case types.SET_END_DATE:
    case types.SET_START_DATE:
    case types.SET_PERIOD:
      state = Object.assign({}, state);
      break;
  }

  return state;
}
